package com.karyadina.util

actual val isWeb: Boolean = true
